import { combineReducers } from 'redux';

import status from './status';

export default combineReducers({
  status,
});
